/**
 * Live Scatter page (live/explore/SCATTER).
 *
 * Thin wrapper: renders the shared project-wide ScatterHistory page in `live` mode — it reads the live session
 * parquet for the active playback window (no datetime-range picker; a Refresh button reloads up to the live edge).
 * See reports/gp50/project/all/explore/ScatterHistory.tsx for the `live` behavior.
 */
import ScatterHistoryPage from "../../project/all/explore/ScatterHistory";

export default function LiveScatterPage(props: Record<string, unknown>) {
  return <ScatterHistoryPage {...props} live={true} />;
}
